// About.jsx
import React from "react";
import "./About.css";
import Banner from '../assets/banner.jpeg';

const About = () => {
  const features = [
    {
      icon: "fa-calendar-check",
      title: "10+ Years Experience",
      description: "Making events beautiful and memorable since 2014"
    },
    {
      icon: "fa-users",
      title: "Expert Team",
      description: "Skilled decorators who understand your dreams and needs"
    },
    {
      icon: "fa-star",
      title: "Premium Quality",
      description: "Using best materials and latest decoration styles"
    },
    {
      icon: "fa-clock",
      title: "24/7 Support",
      description: "Always available to help with your event planning"
    }
  ];

  const services = [
    "Wedding Decor",
    "Corporate Events",
    "Birthday Parties",
    "Anniversary Celebrations",
    "Baby Showers",
    "Engagement Ceremonies",
    "Haldi & Mehndi",
    "Stage Decoration"
  ];

  return (
    <section className="about" id="about">
      <div className="about-container">
        {/* Section Header */}
        <div className="about-header">
          <span className="about-tag">About Us</span>
          <h2 className="about-title">
            We Make Your <span>Events</span> <br />
            Truly Special
          </h2>
          <p className="about-subtitle">
            We turn simple spaces into beautiful memories with our decoration 
            services in Delhi and Gurugram.
          </p>
        </div>

        {/* Main Content */}
        <div className="about-content">
          {/* Left Column - Story */}
          <div className="about-story">
            <div className="about-story-image">
              <img 
                src={Banner} 
                alt="Atoz Events - Decoration Services" 
                className="about-story-img"
                loading="lazy"
              />
              <div className="about-experience-badge">
                <span className="experience-number">10+</span>
                <span className="experience-label">Years of Excellence</span>
              </div>
            </div>
            <div className="about-story-text">
              <h3>Your Dream Event Deserves the Best</h3>
              <p>
                At Atoz Events, we believe every celebration has a special story. 
                With more than 10 years of experience, we create stunning decorations 
                that make your events truly unforgettable.
              </p>
              <p>
                Whether it's a small family gathering or a big wedding, our team 
                works with passion and creativity. We listen to your ideas and 
                bring them to life with elegance and style.
              </p>
              <div className="about-story-stats">
                <div className="story-stat">
                  <span className="story-stat-number">500+</span>
                  <span className="story-stat-label">Events Done</span>
                </div>
                <div className="story-stat">
                  <span className="story-stat-number">100%</span>
                  <span className="story-stat-label">Happy Clients</span>
                </div>
                <div className="story-stat">
                  <span className="story-stat-number">24/7</span>
                  <span className="story-stat-label">Always Available</span>
                </div>
              </div>
              <a href="#contact" className="about-btn">
                <i className="fas fa-envelope"></i> Contact Us
              </a>
            </div>
          </div>

          {/* Right Column - Features Grid */}
          <div className="about-features">
            <div className="features-grid">
              {features.map((feature, index) => (
                <div className="feature-card" key={index}>
                  <div className="feature-icon">
                    <i className={`fas ${feature.icon}`}></i>
                  </div>
                  <h4 className="feature-title">{feature.title}</h4>
                  <p className="feature-description">{feature.description}</p>
                </div>
              ))}
            </div>

            {/* Services List */}
            <div className="about-services">
              <h4 className="services-title">
                <i className="fas fa-concierge-bell"></i> 
                Our Services
              </h4>
              <div className="services-list">
                {services.map((service, index) => (
                  <span className="service-tag" key={index}>
                    <i className="fas fa-check-circle"></i>
                    {service}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="about-trust">
          <div className="trust-item">
            <i className="fas fa-shield-alt"></i>
            <span>Fully Insured</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <i className="fas fa-handshake"></i>
            <span>100% Satisfaction</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <i className="fas fa-trophy"></i>
            <span>Award-Winning</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <i className="fas fa-leaf"></i>
            <span>Eco-Friendly</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;